/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Style = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .p-placeholder {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 100;
  }
`;

export default function ComponentWithFocus({
  children,
  actions = { closed: false, setClosed: () => { }, unFocus: () => { } },
  style = {},
  show = false,
  className,
}) {
  const [placeholderIsVisible, setPlaceholderIsVisible] = useState(true);
  const ref = useRef();

  const checkMouse = useCallback((event) => {
    if (!placeholderIsVisible) {
      if (ref.current) {
        const divRect = ref.current.getBoundingClientRect();
        if (event.clientX >= divRect.left && event.clientX <= divRect.right &&
          event.clientY >= divRect.top && event.clientY <= divRect.bottom) {
          return;
        }
        setPlaceholderIsVisible(true);
        if (typeof actions.unFocus === 'function') {
          actions.unFocus();
        }
      }
    }
  }, [placeholderIsVisible]);

  useEffect(() => {
    document.addEventListener('mousemove', checkMouse);
    return () => document.removeEventListener('mousemov', checkMouse);
  }, [checkMouse]);

  useEffect(() => {
    if (actions.closed) {
      setPlaceholderIsVisible(false);
      actions.setClosed(false);
    }
  }, [actions.closed]);

  return (
    <Style className={className} ref={ref} style={style}>
      {(placeholderIsVisible || show) &&
        <div
          onClick={() => setPlaceholderIsVisible(false)}
          className="p-placeholder"
          style={style}
        />
      }
      {children}
    </Style>
  );
}
